import React from 'react';
import { Helmet } from 'react-helmet-async';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import Autopara1 from '../../../components/Autopara/Autopara1';
import TechServicesPage from '../../../components/Autopara/TechServicesPage';

const Services = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL}/services`;
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <title>
          Adithya Infinity
        </title>
        <meta
          name="description"
          content="Explore our IT and Non-IT services including recruitment, staffing, product engineering, and digital transformation. V Adithya Infinity Pvt Ltd offers intelligent solutions tailored for your business needs."
        />
        <meta
          name="keywords"
          content="V Adithya Infinity services, IT recruitment, Non-IT staffing, product engineering, digital transformation, consulting services, business solutions India, job consultancy India, software development support, HR outsourcing, tech support, hiring solutions, automation services"
        />
        {isDevelopment ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <link rel="canonical" href={canonicalUrl} />
        )}

        {/* OG + Twitter tags */}
        <meta property="og:title" content="Our Services | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="Discover our full suite of IT & Non-IT services including staffing, engineering, and recruitment. We deliver smart business solutions across India."
        />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/services-banner.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Services | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Explore IT & Non-IT services like staffing, engineering, and recruitment from V Adithya Infinity Pvt Ltd."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/services-banner.jpg"
        />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'V Adithya Infinity Pvt Ltd',
            url: canonicalUrl,
            logo: 'https://www.adithyainfinity.com/assets/images/logo.png',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+91-9876543210',
              contactType: 'Customer Service',
              areaServed: 'IN',
              availableLanguage: ['English', 'Hindi', 'Telugu'],
            },
            sameAs: [
              'https://www.linkedin.com/company/vadithyainfinity',
              'https://www.facebook.com/vadithyainfinity',
            ],
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            serviceType: 'IT & Non-IT Recruitment, Staffing, and Engineering Services',
            provider: {
              '@type': 'Organization',
              name: 'V Adithya Infinity Pvt Ltd',
              url: 'https://www.adithyainfinity.com',
              logo: 'https://www.adithyainfinity.com/assets/images/logo.png',
            },
            areaServed: {
              '@type': 'Country',
              name: 'India',
            },
            description:
              'We provide expert IT & Non-IT staffing, recruitment, engineering, automation, and digital transformation services across India.',
          })}
        </script>
      </Helmet>

      <div className="flex flex-col">
        {/* Hero Banner */}
        <ContactPage
          title="OUR SERVICES"
          subTitle="Delivering intelligent engineering and manufacturing solutions."
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="SERVICES"
        />
          <Stats />

        {/* Auto Paragraph + Tech Services */}
        <div className="bg-white py-10 px-4 sm:px-6 md:px-12 lg:px-20">
          <Autopara1 />
          <div className="mt-8">
            <TechServicesPage />
          </div>
        </div>

        {/* CTA Section */}
        <section className="px-4 md:px-12 lg:px-24">
          <MakeTheShift />
        </section>
      </div>
    </>
  );
};

export default Services;
